/**
 * Neutering Discharge Information — uses the discharge letter template.
 */
import { buildDischargeLetter } from '@/frontend/features/printing/documents/discharge/discharge-template.form'

export const neuteringDischarge = buildDischargeLetter({
  id: 'neutering-discharge',
  label: 'Neutering Discharge',
  title: 'Neutering Discharge Information',
  procedureText: (name) => `${name} has had a general anaesthetic for a neutering procedure.`,
})
